import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { appRoutes } from "routes";

import useStyles from "./useStyles";

const PurchaseDisclaimer = (props) => {
  const classes = useStyles();
  const { firstSentence } = props;

  return (
    <div className={classes.root}>
      {firstSentence}, you authorize us to automatically charge the membership fee to your chosen payment method on a
      recurring basis and agree to the{" "}
      <Link to={appRoutes.termsOfSalePath()} target="_blank">
        Terms of Sale
      </Link>
      . You can cancel or change your membership at any time on your{" "}
      <Link to={appRoutes.myAccountPath()} target="_blank">
        Account page
      </Link>
      .
    </div>
  );
};

PurchaseDisclaimer.propTypes = {
  firstSentence: PropTypes.string,
};

PurchaseDisclaimer.defaultProps = {
  firstSentence: "By purchasing",
};

export default PurchaseDisclaimer;
